import {
  DARK_THEME_USER_TAG,
  ENABLED_DARK_THEME_FOR_OLD_USER,
  THEME_MODE_STORAGE_KEY,
  ThemeMode,
} from '@modules/theme/constants';
import { useThemeStore } from '@modules/theme/store/useThemeStore';
import { useHasUserTag } from '@modules/userTags/hooks';
import { useAddUserTags } from '@modules/userTags/hooks/useAddUserTags';
import dayjs from 'dayjs';
import Locker from 'lockr';
import { useEffect } from 'react';
import { QueryStatus } from 'v2/core/repository/edge-server/types';
import { useGetUserMaybe } from 'v2/core/services/user';

export const ThemeModeHandler = () => {
  const user = useGetUserMaybe();
  const setMode = useThemeStore(({ setMode }) => setMode);

  const isThemeModeStored = Boolean(Locker.get(THEME_MODE_STORAGE_KEY));
  const isOldUser = user?.createdAt?.isBefore(dayjs('2023-07-04'));

  const { hasTag, status: hasTagStatus } = useHasUserTag();
  const [addUserTags] = useAddUserTags();

  const hasNotEnabledDarkThemeForOldUser =
    isOldUser &&
    !hasTag(ENABLED_DARK_THEME_FOR_OLD_USER) &&
    hasTagStatus === QueryStatus.SUCCESS_COMPLETED;

  // set user tag if user is old and add user-tag to do this only once
  useEffect(() => {
    if (hasNotEnabledDarkThemeForOldUser) {
      addUserTags([ENABLED_DARK_THEME_FOR_OLD_USER, DARK_THEME_USER_TAG]);
    }
  }, [addUserTags, hasNotEnabledDarkThemeForOldUser]);

  const hasDarkThemeUserTag = hasTag(DARK_THEME_USER_TAG);

  const shouldApplyDarkTheme =
    !isThemeModeStored &&
    (hasDarkThemeUserTag || hasNotEnabledDarkThemeForOldUser);

  useEffect(() => {
    if (shouldApplyDarkTheme) {
      setMode(ThemeMode.DARK);
    }
  }, [shouldApplyDarkTheme, setMode]);
};
